import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ConfigurationProfilesDataProviderFactory } from '../factory/ConfigurationProfilesDataProviderFactory';
import { ConfigurationProfilesBaseDataProvider } from '../dataProvider/ConfigurationProfilesBaseDataProvider';
import { AssignToPoliciesResponse } from '../types';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class ConfigurationProfilesRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ConfigurationProfilesDataProviderFactory;
  public dataProvider: ConfigurationProfilesBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ConfigurationProfilesDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<Array<Target>> {
    return await this.getAvailableCompanies();
  }

  public async getAvailableCompanies(): Promise<Array<Target>>{
    let response;
    try {
      response = await this.dataProvider.getAvailableCompanies();
    } catch (err) {
      console.error(err);
    }

    return response.data.map((item) => {
      return {
        companyId: item._id,
        companyName: item.name,
      };
    });
  }

  public async assignListToPolicies(companyId: string, listId: string, policyIds: string[]): Promise<AssignToPoliciesResponse> {
    let response;
    try {
      response = await this.dataProvider.assignListToPolicies(companyId, listId, policyIds);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

  public async removeRecords(records): Promise<{ success: boolean }> {
    let response;
    try {
      response = await this.dataProvider.removeRecords(records);
    } catch (err) {
      console.error(err);
    }
    return response;
  }
}
